import React from 'react'

import { convertComponents } from '../factory'
import HeroSub from '../Hero/hero-sub'
import Accordion from '../Accordion/accordion'

import './faq-page.scss'

class FaqPageSearch extends React.Component {
  constructor(props) {
    super(props)

    this.accordionContent = this.props.content.content.filter(c => c.__typename === 'ContentfulAccordion').pop()
    this.state = {
      searchString: '',
      openedItems: {}
    }
  }

  componentDidUpdate(oldProps) {
    if (this.props.content != oldProps.content) {
      this.setState({
        searchString: this.props.searchString
      })
    }
  }

  onChange(event) {
    const searchString = event.target.value

    if (searchString.length > 2) {
      this.setState({
        searchString,
        openedItems: this.searchContent(searchString, this.accordionContent)
      })
    } else {
      this.setState({
        searchString
      })
    }
  }


  searchContent(searchString, content) {
    const openedItems = {}
    const normalizedString = searchString.toLowerCase()

    const hasMatch = (item) => {
      const hasContent = item.content && item.content.content && typeof(item.content.content.toLowerCase()) == "string" && item.content.content.toLowerCase().includes(normalizedString)
      const hasTitle = item.title && typeof(item.title.toLowerCase()) == "string" && item.title.toLowerCase().includes(normalizedString)

      return hasContent || hasTitle
    }

    content.items.forEach((item, index) => {
      openedItems[`${index}`] = hasMatch(item)

      if (item.subItems) {
        item.subItems.forEach((subItem, subIndex) => { 
            const isMatch = hasMatch(subItem)
            openedItems[`${index}.${subIndex}`] = isMatch

            if (isMatch) {
              openedItems[`${index}`] = true
            }
        })
      }
    })

    return openedItems
  }

  render() {
    const { content, hero } = this.props.content
    const { lang, localization } = this.props
    const highlightWord = this.state.searchString.length > 2 ? this.state.searchString : null

    const components = convertComponents({
      components: content.filter(c => c.__typename !== 'ContentfulAccordion'), 
      lang,
      localization
    })

    return (
      <div className="subpage-container faq-page-container" data-cy="faq-page-search">
        <HeroSub content={ hero } lang={lang} localization={localization}></HeroSub>

        <div>
            <div className="search-box-container">
                <input 
                  className="input light"
                  type="text"
                  placeholder={ localization('faq.placeholder') }
                  onChange={event => this.onChange(event) } />
                <button className='btn primary' onClick={ () => this.search(this.state.searchString) }>{ localization('global.search') }</button>
              </div>

            <h5 className="sub-title">{ localization('faq.alternative') }</h5>

            <Accordion content={this.accordionContent} lang={lang} openedItems={ this.state.openedItems } highlightWord={ highlightWord } />

            { components }
        </div>
      </div>
    )
  }
}

export default FaqPageSearch



// WEBPACK FOOTER //
// ./src/components/FaqPage/faq-page.js